import { Component, Input, OnInit, OnChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-office-header',
  templateUrl: './office-header.component.html',
  styleUrls: ['./office-header.component.scss']
})
export class OfficeHeaderComponent implements OnInit, OnChanges {
  @Input() officeName: string = '';

  logoImageUrl: string = '';
  logoLoadError: boolean = true;

  ngOnInit(): void {
    if (this.officeName) {
      this.logoImageUrl = 'assets/images/flag/' + this.officeName + '.png';
      this.logoLoadError = false;
    }
  }

  ngOnChanges(): void {
    if (this.officeName) {
      this.logoImageUrl = 'assets/images/flag/' + this.officeName + '.png';
      this.logoLoadError = false;
    }
  }
}
